import type { ReactNode } from 'react'
import React from 'react'
import { ShowIf } from '../ShowIf'
import { useToggle } from 'react-use'
import { HorizontalStack } from '../HorizontalStack'
import { Stack } from 'react-bootstrap'
import { HideIf } from '../HideIf'
import { Switch } from '../Switch'
import { CollapseControl } from '../CollapseControl'
export type SectionNameProps = {
  title?: ReactNode
  description?: any
  children?: React.ReactNode
  showDivision?: boolean
  isCollapsible?: boolean
  initialCollapse?: boolean
  sideContent?: ReactNode
}

export const SectionName = ({
  title,
  description,
  children,
  showDivision = true,
  isCollapsible = false,
  initialCollapse = true,
  sideContent,
}: SectionNameProps) => {
  const [collapse, setCollapse] = useToggle(initialCollapse)

  return (
    <Stack>
      <HorizontalStack className="justify-content-between">
        <div>
          <a
            href="/"
            onClick={(e) => {
              e.preventDefault()
              setCollapse()
            }}
          >
            <b className=" m-0 p-0">{title}</b>
          </a>
          <div>{description}</div>
        </div>
        <div>
          <ShowIf condition={!!sideContent}>
            {sideContent}
          </ShowIf>
          <ShowIf condition={!sideContent && isCollapsible}>
            <CollapseControl show={collapse} setShow={setCollapse} />
          </ShowIf>
        </div>
      </HorizontalStack>

      <ShowIf condition={!!children}>
        {showDivision && <hr />}

        <Switch expression={isCollapsible}>
          {{
            true: <HideIf condition={collapse}>{children}</HideIf>,
            false: children,
          }}
        </Switch>
      </ShowIf>
    </Stack>
  )
}
